export default "__VITE_ASSET__zff5dHNj__"